import { useMemo } from 'react';

const CAMPOS_ENDERECO = ['logradouro', 'numero', 'bairro', 'cidade', 'uf', 'cep'];

export default function useProgresso(dados, modulos = [], anexosPadrao = []) {
  return useMemo(() => {
    if (!dados) return { percentual: 0, pendencias: [], porSecao: {} };

    let totalItens = 0;
    let itensOk = 0;
    const pendencias = [];
    const porSecao = {};

    // Dados Gerais
    const end = dados.dadosGerais?.endereco || {};
    const endOk = CAMPOS_ENDERECO.every(c => end[c]?.toString().trim());
    const emailOk = !!dados.dadosGerais?.emailCobranca?.trim();
    totalItens += 2;
    let okDados = 0;
    if (endOk) { itensOk++; okDados++; } else pendencias.push('Dados Gerais: endereço não preenchido');
    if (emailOk) { itensOk++; okDados++; } else pendencias.push('Dados Gerais: e-mail de cobrança não preenchido');
    porSecao.dadosGerais = Math.round((okDados / 2) * 100);

    // Empresas
    const empresas = dados.empresas || [];
    let okEmpresas = 0; let totalEmpresas = 0;
    if (empresas.length === 0) {
      totalItens++; totalEmpresas++;
      pendencias.push('Empresas: nenhuma empresa cadastrada');
    } else {
      empresas.forEach((emp, i) => {
        const ee = emp.endereco || {};
        const eeOk = CAMPOS_ENDERECO.every(c => ee[c]?.toString().trim());
        const eEmailOk = !!emp.emailCobranca?.trim();
        totalItens += 2; totalEmpresas += 2;
        if (eeOk) { itensOk++; okEmpresas++; } else pendencias.push(`Empresa ${emp.nome || i + 1}: endereço não preenchido`);
        if (eEmailOk) { itensOk++; okEmpresas++; } else pendencias.push(`Empresa ${emp.nome || i + 1}: e-mail de cobrança não preenchido`);
      });
    }
    porSecao.empresas = totalEmpresas > 0 ? Math.round((okEmpresas / totalEmpresas) * 100) : 0;

    // Módulos
    const modulosContratados = dados.modulosContratados || [];
    let okModulos = 0; let totalModulos = 0;
    modulosContratados.forEach(modId => {
      const mod = modulos.find(m => m.id === modId);
      if (!mod) return;
      mod.itens.forEach(item => {
        totalItens++; totalModulos++;
        const val = dados.modulosValoresPrincipais?.[modId]?.[item.id];
        const respondido = item.tipo === 'faixa'
          ? (val?.de !== null && val?.de !== undefined && val?.ate !== null && val?.ate !== undefined)
          : (val !== null && val !== undefined);
        if (respondido) { itensOk++; okModulos++; }
        else pendencias.push(`Módulo ${mod.nome}: "${item.label}" não respondido`);
      });
    });
    porSecao.modulos = totalModulos > 0 ? Math.round((okModulos / totalModulos) * 100) : (modulosContratados.length === 0 ? 100 : 0);

    // Anexos
    const extras = (dados.tiposAnexosExtras || []);
    const todosAnexos = [...anexosPadrao, ...extras.map(t => ({ id: t.id, label: t.label }))];
    let okAnexos = 0;
    todosAnexos.forEach(tipo => {
      totalItens++;
      const env = (dados.anexos || []).some(a => a.tipoId === tipo.id && a.arquivo);
      if (env) { itensOk++; okAnexos++; } else pendencias.push(`Anexo pendente: ${tipo.label}`);
    });
    porSecao.anexos = todosAnexos.length > 0 ? Math.round((okAnexos / todosAnexos.length) * 100) : 100;

    // Usuários
    totalItens++;
    const temUsuario = (dados.usuarios || []).length > 0;
    if (temUsuario) { itensOk++; porSecao.usuarios = 100; }
    else { pendencias.push('Usuários: nenhum usuário cadastrado'); porSecao.usuarios = 0; }

    const percentual = totalItens > 0 ? Math.round((itensOk / totalItens) * 100) : 0;
    return { percentual, pendencias, porSecao };
  }, [dados, modulos, anexosPadrao]);
}
